import { render, staticRenderFns } from "./subSchoolList.vue?vue&type=template&id=7cada2aa&scoped=true&"
import script from "./subSchoolList.vue?vue&type=script&lang=js&"
export * from "./subSchoolList.vue?vue&type=script&lang=js&"
import style0 from "./subSchoolList.vue?vue&type=style&index=0&id=7cada2aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cada2aa",
  null
  
)

export default component.exports